import { Switch } from "antd";
import Cookies from "js-cookie";
import type React from "react";
import { useState } from "react";

import { Tooltip } from "metabase/ui";

interface FreezeState {
  open: boolean;
}

export function SmartFreeze(): JSX.Element {
  const smartFreezeStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
  };

  const smartFreezeText: React.CSSProperties = {
    fontWeight: "normal",
    color: "black",
  };

  const [freeze, setFreeze] = useState<FreezeState>({
    open:
      Cookies.get("metabase.smart.freeze") === "true" ||
      Cookies.get("metabase.smart.freeze") === undefined,
  });

  const changeFreeze = (opened: boolean) => {
    setFreeze(() => ({
      open: opened,
    }));
    try {
      Cookies.set("metabase.smart.freeze", String(opened), {
        expires: 365 * 10,
      });
    } catch (e) {
      console.error("set smart freeze:", e);
    }
  };

  return (
    <Tooltip label="The type of the first frozen column is date/datetime by default.">
      <div style={smartFreezeStyle}>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <span style={smartFreezeText}>Smart Freeze:</span>
        <Switch
          style={{ marginLeft: "5px" }}
          checked={freeze.open}
          onChange={changeFreeze}
        />
      </div>
    </Tooltip>
  );
}
